import { View } from "@react-pdf/renderer";
import { formatDateToDD_MMM_YYYY } from "../../../../../helpers/functions";
import {
  notificationMethodOptions,
  notificationTypeOptions,
} from "../../../../patient/clinical-services/service-steps/education/data";
import { COLORS } from "../../../../forms/pdf-components/PdfStyles";
import { PdfH2 } from "../../../../forms/pdf-components/PdfText";
import {
  PdfRow,
  PdfCol,
  PdfSection,
  PdfVerticalDivider,
} from "../../../../forms/pdf-components/PdfLayout";
import { PdfDataField } from "../../../../forms/pdf-components/PdfDataField";

/** Resolve a multi-value notification type string → display label */
const getMultiDropDownLabel = (options, value) => {
  if (!value) return "n/a";
  const values = String(value)
    .split(",")
    .map((v) => v.trim());
  const matched = values
    .map(
      (val) =>
        options.find((opt) => opt.value === val)?.header ||
        options.find((opt) => opt.value === val)?.label
    )
    .filter(Boolean);
  return matched.length > 0 ? matched.join(", ") : "n/a";
};

/**
 * PdfNotificationOfService
 *
 * Props:
 *   documentation — formRoot?.notification object
 *                   { notificationType: string[], dateOfNotification, methodOfNotification }
 */
export const PdfNotificationOfService = ({ documentation = {} }) => {
  const dateOfNotification = documentation?.dateOfNotification
    ? formatDateToDD_MMM_YYYY(documentation.dateOfNotification)
    : "";

  const notificationTypeDisplay = getMultiDropDownLabel(
    notificationTypeOptions,
    documentation?.notificationType?.join(", ")
  );

  const methodDisplay =
    notificationMethodOptions.find(
      (o) => o.value === documentation?.methodOfNotification
    )?.label || "";

  return (
    <PdfSection>
      <View
        style={{
          borderWidth: 1,
          borderColor: COLORS.border,
          backgroundColor: COLORS.bg,
          padding: 6,
        }}
      >
        {/* 2×2 grid */}
        <PdfRow style={{ marginBottom: 4 }}>
          <PdfCol>
            <PdfH2>Notification of Service</PdfH2>
          </PdfCol>
          <PdfVerticalDivider />
          <PdfCol style={{ paddingLeft: 6 }}>
            <PdfDataField
              label="Date of Notification:"
              value={dateOfNotification}
            />
          </PdfCol>
        </PdfRow>

        <View
          style={{
            borderTopWidth: 1,
            borderTopColor: COLORS.border,
            marginBottom: 4,
          }}
        />

        <PdfRow>
          <PdfCol>
            <PdfDataField
              label="Notification Type:"
              value={notificationTypeDisplay}
            />
          </PdfCol>
          <PdfVerticalDivider />
          <PdfCol style={{ paddingLeft: 6 }}>
            <PdfDataField
              label="Method of Notification:"
              value={methodDisplay}
            />
          </PdfCol>
        </PdfRow>
      </View>
    </PdfSection>
  );
};
